import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'navbar-footer',
  templateUrl: './navbar-footer.component.html',
  styleUrls: ['./navbar-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavBarFooterComponent {
    @Input() public navLinks: any[];
}
